import { render, staticRenderFns } from "./addclaima.vue?vue&type=template&id=0a988e9e&scoped=true&"
import script from "./addclaima.vue?vue&type=script&lang=js&"
export * from "./addclaima.vue?vue&type=script&lang=js&"
import style0 from "./addclaima.vue?vue&type=style&index=0&id=0a988e9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a988e9e",
  null
  
)

export default component.exports